import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Link = styled.button`
  -webkit-appearance: initial;
  border: 0px;
  background: none;
  padding: 0;
  font-size: 14px;
  padding: 5px 0 5px 0;
  margin: 0;
  width: 90%;
  text-align: left;
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }

  :focus {
    outline: 0px auto -webkit-focus-ring-color;
  }
`

const List = styled.ul`
  margin-left: 24px !important;
  li {
    padding: 5px 0 5px 0 !important;
    border-bottom: 0px !important;
  }
`

const Menu = ({ setMenuOption }) => (
  <div className='col-lg-4'>
    <div id='firo-sidebar' className='firo-sidebar'>
      <div className='nile-widget layout-1 widget_meta'>
        <div className='title text-main-color'>Table of Contents</div>
        <ul>
          <li><Link onClick={() => setMenuOption('debian-and-ubuntu-based-distributions')}>Debian and Ubuntu based distributions (deb)</Link>
            <List>
              <li><Link onClick={() => setMenuOption('installation-instructions-debian-and-ubuntu')}>Installation instructions</Link></li>
              <li><Link onClick={() => setMenuOption('manual-installation-debian-and-ubuntu')}>Manual installation</Link></li>
            </List>
          </li>
          <li><Link onClick={() => setMenuOption('enterprise-linux-based-distributions')}>Enterprise Linux based distributions (rpm)</Link>
            <List>
              <li><Link onClick={() => setMenuOption('installation-instructions-enterprise-linux')}>Installation instructions</Link></li>
            </List>
          </li>
          <li><Link onClick={() => setMenuOption('snap-packages')}>Snap packages</Link></li>
          <li><Link onClick={() => setMenuOption('test')}>Test</Link></li>
          <li><Link onClick={() => setMenuOption('faq')}>FAQ</Link></li>
          <li><Link onClick={() => setMenuOption('requested-distributions')}>Requested Distributions</Link></li>
          <li><Link onClick={() => setMenuOption('license')}>License</Link></li>
        </ul>
      </div>
    </div>
  </div>
)

Menu.propTypes = {
  setMenuOption: PropTypes.func
}

export default Menu
